module.exports = __webpack_public_path__ + "static/media/hyper-3.e0298bf7.PNG";